import { render, staticRenderFns } from "./Tenant.vue?vue&type=template&id=503e3ace&"
import script from "./Tenant.vue?vue&type=script&lang=ts&"
export * from "./Tenant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports